import keycloakAxios from '@/services/axios';

export const getCompanyInfos = async (
  companyId?: string,
  publicCompany?: boolean
) => {
  let endpoint = 'company/';

  if (companyId) {
    endpoint = `company/${companyId}`;
  }
  if (publicCompany) {
    endpoint = `company/public/${companyId}`;
  }

  const response = await keycloakAxios.get(endpoint);

  if (response.status >= 300) {
    throw new Error(
      `Error getting company infos: Invalid status code: ${response.status}`
    );
  }

  if (response.data.imprint === null) {
    response.data.imprint = '';
  }

  return response.data;
};
